import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { updateMetaTags, getMetaTagsForRoute, type MetaTags } from '@/utils/metaTags'

export function useMetaTags() {
  const route = useRoute()

  // Function to set meta tags for current route
  const setMetaTags = (meta: MetaTags): void => {
    updateMetaTags(meta)
  }

  // Function to set meta tags for a specific route
  const setMetaTagsForRoute = (routePath: string): void => {
    const meta = getMetaTagsForRoute(routePath)
    if (meta) {
      updateMetaTags(meta)
    }
  }

  // Function to set meta tags for current route automatically
  const setCurrentRouteMetaTags = (): void => {
    const meta = getMetaTagsForRoute(route.path)
    if (meta) {
      updateMetaTags(meta)
    }
  }

  // Auto-update meta tags when route changes
  const enableAutoMetaTags = (): void => {
    // Set meta tags on mount
    onMounted(() => {
      setCurrentRouteMetaTags()
    })

    // Watch for route changes
    watch(
      () => route.path,
      () => {
        setCurrentRouteMetaTags()
      }
    )
  }

  return {
    setMetaTags,
    setMetaTagsForRoute,
    setCurrentRouteMetaTags,
    enableAutoMetaTags
  }
}
